<template>
    <div class="container">
      <NavMenu class="nav_menu"></NavMenu>
      <UserEcharts class="content-area"></UserEcharts>
    </div>
  </template>
  
  <script>
  import NavMenu from '@/components/NavMenu.vue'
  import UserEcharts from '@/components/UserEcharts.vue'
  
  export default {
    components: { NavMenu, UserEcharts }
  }
  </script>
  
  <style scoped>
  .container {
    display: flex;
    height: 100vh;
  }
  .nav_menu {
    width: 280px !important; /* 覆盖全局样式 */
    flex: 0 0 auto !important; /* 禁止 NavMenu 伸缩 */
    min-width: 280px !important; /* 确保最小宽度 */
    position: static !important; /* 重置布局属性 */
  }
  
  .content-area {
    flex: 1; /* 占据剩余空间 */
    overflow: auto; /* 如果内容超出，显示滚动条 */
  }
  
  .container * {
    box-sizing: border-box; /* 确保宽度包含 padding 和 border */
  }
  </style>